// extracted by mini-css-extract-plugin
export default {"container":"inputMessage_container__2TFdF","input":"inputMessage_input__rZELr","sendTextContainer":"inputMessage_sendTextContainer__H6bDe","text":"inputMessage_text__5gzXS"};